import { NgModule } from '@angular/core';
import { MsDialogErrorComponent } from './ms-dialog-error.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';

@NgModule({
	declarations: [MsDialogErrorComponent],
	imports: [SharedLibsModule, MsButtonModule],
	exports: [MsDialogErrorComponent],
	providers: [],
})
export class MsDialogErrorModule {}
